export function getScoreText(score){

    return (score / 2).toFixed(1);

}



// WEBPACK FOOTER //
// ./src/utils/getScoreText/index.js